// client/requestHandler.ts
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import "../metaDataStore";
import { generateOperationString } from "../utils/queryGeneration";
import { BaseQLClient } from "./baseqlClient";
function handleClientRequest(argNames, opType, op) {
  return function(...params) {
    const variables = Object.fromEntries(argNames.map((name, index) => [name, params[index]]));
    const metadata = { calledOn: this._class };
    return (gqlFields) => {
      switch (opType) {
        case "subscription":
        case "subscribableQuery":
          return from(BaseQLClient.getRequestHandler()).pipe(
            switchMap((handler) => {
              if (!handler)
                throw new Error(
                  "handleRequest: No requestHandler defined! Please define an requestHandler with clientConfig.setRequestHandler"
                );
              return handler.subscription(op, {
                variables,
                metadata,
                subscription: generateOperationString("subscription", op, gqlFields)
              });
            })
          );
        case "query":
          return BaseQLClient.getRequestHandler().then((handler) => {
            if (!handler)
              throw new Error(
                "handleRequest: No requestHandler defined! Please define an requestHandler with clientConfig.setRequestHandler"
              );
            return handler.query(op, {
              variables,
              metadata,
              query: generateOperationString("query", op, gqlFields)
            });
          });
        case "mutation":
          return BaseQLClient.getRequestHandler().then((handler) => {
            if (!handler)
              throw new Error(
                "handleRequest: No requestHandler defined! Please define an requestHandler with clientConfig.setRequestHandler"
              );
            return handler.mutation(op, {
              variables,
              metadata,
              mutation: generateOperationString("mutation", op, gqlFields)
            });
          });
        default:
          throw new Error("unsupported opType");
      }
    };
  };
}
export {
  handleClientRequest
};
